import { Box } from "@mui/material"
import { MainPageContentContainer } from "components/MainPageContentContainer"
import { CardHolderFilter } from "layouts/card-holder/filter/cardHolderFilter.tsx"
import { DriversContainer } from "layouts/card-holder/drivers/container.tsx"
import { CardHolderPageProvider } from "layouts/card-holder/context/provider"
import { OreveFooter } from "components/OreveFooter.tsx"
import { OreveButton } from "components/button/OreveButton.tsx"
import { AddDriverButtonIcon } from "layouts/rfid/rfid-dashboard/icons-rfid-page.tsx"
import { useCardHolderContext } from "layouts/card-holder/context/useCardHolderContext.ts"
import { useOrganization } from "context/OrganizationContext"

export const DriversPage = () => {
    const { organizationId } = useOrganization()

    return (
        <CardHolderPageProvider key={organizationId ?? "no-org"}>
            <DriversPageView />
        </CardHolderPageProvider>
    )
}

const DriversPageView = () => {
    const { setOpenAddCardHolder } = useCardHolderContext()

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "1.5rem",
            }}
        >
            <CardHolderFilter />
            <MainPageContentContainer
                sx={{
                    p: "2.25rem",
                }}
            >
                <DriversContainer />
            </MainPageContentContainer>
            <OreveFooter>
                <OreveButton
                    sx={{
                        position: "sticky",
                        bottom: "1.5rem",
                        alignSelf: "self-start",
                        zIndex: 10,
                    }}
                    icon={AddDriverButtonIcon}
                    value="Ajouter un conducteur"
                    variant="contained"
                    color="primary"
                    onClick={() => setOpenAddCardHolder(true)}
                    data-cy="nav_drivers__footer--add-driver"
                />
            </OreveFooter>
        </Box>
    )
}
